import React from "react";
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import {
  Visibility as VisibilityIcon,
  PersonAdd as PersonAddIcon,
} from "@mui/icons-material";

const SubConversationMenu = ({ anchorEl, open, onClose, onAction }) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      PaperProps={{
        sx: {
          minWidth: 180,
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
          borderRadius: 2,
        },
      }}
    >
      <MenuItem onClick={() => onAction("view")}>
        <ListItemIcon>
          <VisibilityIcon sx={{ fontSize: 18, color: "#7C3AED" }} />
        </ListItemIcon>
        <ListItemText>
          <Typography sx={{ fontSize: "0.875rem", textTransform: "lowercase" }}>
            view details
          </Typography>
        </ListItemText>
      </MenuItem>

      <MenuItem onClick={() => onAction("addMember")}>
        <ListItemIcon>
          <PersonAddIcon sx={{ fontSize: 18, color: "#7C3AED" }} />
        </ListItemIcon>
        <ListItemText>
          <Typography
            sx={{
              fontSize: "0.875rem",
              textTransform: "lowercase",
              color: "#7C3AED",
            }}
          >
            add member
          </Typography>
        </ListItemText>
      </MenuItem>
    </Menu>
  );
};

export default React.memo(SubConversationMenu);
